export const allSelector = (state) => state?.serviceReducer?.all;
